"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MemoryStorage =
/*#__PURE__*/
function () {
  function MemoryStorage() {
    _classCallCheck(this, MemoryStorage);

    _defineProperty(this, "data", {});
  }

  _createClass(MemoryStorage, [{
    key: "clear",

    /**
     * Clear the whole storage
     */
    value: function clear() {
      this.data = {};
    }
    /**
     * Get an item by key
     * @param key
     */

  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.data[key] || null;
    }
    /**
     * Set a key/value pair
     * @param key
     * @param value
     */

  }, {
    key: "setItem",
    value: function setItem(key, value) {
      this.data[key] = value;
    }
    /**
     * Remove an item by key
     * @param key
     */

  }, {
    key: "removeItem",
    value: function removeItem(key) {
      delete this.data[key];
    }
    /**
     * Get the key by numeric index
     * @param index
     */

  }, {
    key: "key",
    value: function key(index) {
      var i = 0;

      for (var _key in this.data) {
        if (this.data.hasOwnProperty(_key)) {
          if (i === index) {
            return _key;
          }

          i += 1;
        }
      }

      return null;
    }
  }, {
    key: "length",

    /**
     * Get the number of items
     */
    get: function get() {
      return Object.keys(this.data).length;
    }
  }]);

  return MemoryStorage;
}();

exports.default = MemoryStorage;